import Vue from 'vue'
import Vuex from 'vuex'

import Server from './modules/server.js'
import Logs from './modules/logs.js'
import Monitoring from './modules/monitoring.js'

import ProviderOdf from './modules/provider/odf.js'

import MainArea from './modules/main/area.js'
import MainPerson from './modules/main/person.js'

import SportFootballActionDestination from './modules/sport/football/action/destination.js'
import SportFootballActionDetail1 from './modules/sport/football/action/detail1.js'
import SportFootballActionOrigin from './modules/sport/football/action/origin.js'

import SportFootballMatch from './modules/sport/football/match'
import SportFootballTeam from './modules/sport/football/team.js'

import SportClassification from './modules/sport/sport/classification.js'
import SportCompetitor from './modules/sport/sport/competitor.js'
import SportCompetitorQualify from './modules/sport/sport/competitorQualify.js'
import SportCompetitorPerson from './modules/sport/sport/competitorPerson.js'
import SportCompetitorRecord from './modules/sport/sport/competitorRecord.js'
import SportCompetitorScore from './modules/sport/sport/competitorScore.js'
import SportCompetitorStatus from './modules/sport/sport/competitorStatus.js'
import SportCompetition from './modules/sport/sport/competition.js'
import SportDay from './modules/sport/sport/day.js'
import SportDiscipline from './modules/sport/sport/discipline.js'
import SportEvent from './modules/sport/sport/event.js'
import SportEventUnit from './modules/sport/sport/eventUnit.js'
import SportGame from './modules/sport/sport/game.js'
import SportGameStatus from './modules/sport/sport/gameStatus.js'
import SportGameStatusDiscipline from './modules/sport/sport/gameStatusDiscipline.js'
import SportGender from './modules/sport/sport/gender.js'
import SportGroupType from './modules/sport/sport/groupType.js'
import SportRoundType from './modules/sport/sport/roundType.js'
import SportScore from './modules/sport/sport/score.js'
import SportScoreDiscipline from './modules/sport/sport/scoreDiscipline.js'
import SportScoreType from './modules/sport/sport/scoreType.js'
import SportScoreTypeHelper from './modules/sport/sport/scoreTypeHelper.js'
import SportScoreTypeUnit from './modules/sport/sport/scoreTypeUnit.js'
import SportSeason from './modules/sport/sport/season.js'
import Sport from './modules/sport/sport/sport.js'
import SportTeam from './modules/sport/sport/team.js'
import SportWonTiedLost from './modules/sport/sport/wonTiedLost.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Server: Server,
    Monitoring: Monitoring,
    ProviderOdf: ProviderOdf,
    Logs: Logs,
    iDebug: false,
    Sport: {
      namespaced: true,
      modules: {
        Classification: SportClassification,
        Competitor: SportCompetitor,
        CompetitorQualify: SportCompetitorQualify,
        CompetitorPerson: SportCompetitorPerson,
        CompetitorRecord: SportCompetitorRecord,
        CompetitorScore: SportCompetitorScore,
        CompetitorStatus: SportCompetitorStatus,
        Competition: SportCompetition,
        Discipline: SportDiscipline,
        Day: SportDay,
        Event: SportEvent,
        EventUnit: SportEventUnit,
        Football: {
          namespaced: true,
          modules: {
            Action: {
              namespaced: true,
              modules: {
                Destination: SportFootballActionDestination,
                Detail1: SportFootballActionDetail1,
                Origin: SportFootballActionOrigin
              }
            },
            Match: SportFootballMatch,
            Team: SportFootballTeam
          }
        },
        Game: SportGame,
        GameStatus: SportGameStatus,
        GameStatusDiscipline: SportGameStatusDiscipline,
        Gender: SportGender,
        GroupType: SportGroupType,
        RoundType: SportRoundType,
        Score: SportScore,
        ScoreDiscipline: SportScoreDiscipline,
        ScoreType: SportScoreType,
        ScoreTypeHelper: SportScoreTypeHelper,
        ScoreTypeUnit: SportScoreTypeUnit,
        Season: SportSeason,
        Sport: Sport,
        Team: SportTeam,
        WonTiedLost: SportWonTiedLost
      }
    },
    Main: {
      namespaced: true,
      modules: {
        Person: MainPerson,
        Area: MainArea
      }
    }
  }
})
